import { Component, Host, HostBinding, Input, OnInit, Optional } from '@angular/core'
import { FormGroup, FormGroupDirective } from '@angular/forms'
import { ThemePalette } from '@angular/material/core'

@Component({
  selector: 'lin-form-submit-button-upd',
  templateUrl: './form-submit-button-upd.component.html',
  styleUrls: ['./form-submit-button-upd.component.scss'],
  standalone: false,
})
export class FormSubmitButtonUpdComponent implements OnInit {
  @HostBinding('class.linxio-form-submit-button') buttonClass = true
  @Input() color: ThemePalette = 'accent'
  @Input() isLoading = false
  @Input() isDisabled = false

  form: FormGroup

  constructor(@Host() @Optional() private formDirective: FormGroupDirective) {}

  ngOnInit() {
    this.form = this.formDirective && this.formDirective.form
  }
}
